import * as types from '../constants/ActionTypes';
import * as socketStatus from '../constants/SocketStatus';

export const socketConnect = isWebappUser => ({
  type: types.SOCKET_CONNECTING,
  payload: {
    status: socketStatus.SOCKET_CONNECTING,
    isWebappUser,
  },
});

export const socketConnectedSuccess = () => ({
  type: types.SOCKET_CONNECT_SUCCESS,
  payload: {
    status: socketStatus.SOCKET_CONNECTED,
  },
});
export const socketReconnect = () => ({
  type: types.SOCKET_RECONNECT,
});
export const socketConnectFailed = () => ({
  type: types.SOCKET_CONNECT_FAIL,
  payload: {
    status: socketStatus.SOCKET_DISCONNECTED,
  },
});

export const maximumSocketReconnectAttemptsReached = maximumReconnectsReached => ({
  type: types.MAXIMUM_SOCKET_RECONNECT_ATTEMPTS_REACHED,
  payload: {
    maximumReconnectsReached: maximumReconnectsReached,
  },
});
